/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Secure_Desc6Inputs */

const en_svc_browser_extensions_secure_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Least-privilege permissions, no remote code, and input sanitization, extensions that pass audit clean.`)
};

const ar_svc_browser_extensions_secure_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صلاحيات بأقل نطاق ولا كود عن بُعد وتنقية مدخلات, إضافات تجتاز التدقيق نظيفة.`)
};

const bn_svc_browser_extensions_secure_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লিস্ট-প্রিভিলেজ পারমিশন, নো রিমোট কোড, ইনপুট স্যানিটাইজেশন, অডিট পরিষ্কারভাবে পাস করা এক্সটেনশন।`)
};

const de_svc_browser_extensions_secure_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungen mit den geringsten Rechten, kein Remote-Code und Eingabebereinigung, Erweiterungen, die jedes Audit bestehen.`)
};

const es_svc_browser_extensions_secure_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permisos mínimos, sin código remoto y sanitización de entradas, extensiones que pasan la auditoría sin observaciones.`)
};

const fr_svc_browser_extensions_secure_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisations minimales, pas de code distant et sanitization des entrées, des extensions qui passent l'audit haut la main.`)
};

const pt_svc_browser_extensions_secure_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissões mínimas, sem código remoto e sanitização de entradas, extensões que passam na auditoria sem observações.`)
};

const zh_svc_browser_extensions_secure_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最低权限、无远程代码、输入清理、通过审核的扩展。`)
};

const tr_svc_browser_extensions_secure_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En az ayrıcalık, uzak kod yok, input sanitization, denetimi temiz geçen uzantılar.`)
};

const ru_svc_browser_extensions_secure_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Права least-privilege, никакого remote-кода и санитизация ввода: расширения, проходящие аудит чисто.`)
};

const pl_svc_browser_extensions_secure_desc6 = /** @type {(inputs: Svc_Browser_Extensions_Secure_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uprawnienia least-privilege, zero zdalnego kodu i sanityzacja inputu, rozszerzenia przechodzące audyt czysto.`)
};

/**
* | output |
* | --- |
* | "Least-privilege permissions, no remote code, and input sanitization, extensions that pass audit clean." |
*
* @param {Svc_Browser_Extensions_Secure_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_secure_desc6 = /** @type {((inputs?: Svc_Browser_Extensions_Secure_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Secure_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_secure_desc6(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_secure_desc6(inputs)
	if (locale === "de") return de_svc_browser_extensions_secure_desc6(inputs)
	if (locale === "es") return es_svc_browser_extensions_secure_desc6(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_secure_desc6(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_secure_desc6(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_secure_desc6(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_secure_desc6(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_secure_desc6(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_secure_desc6(inputs)
	return en_svc_browser_extensions_secure_desc6(inputs)
});
export { svc_browser_extensions_secure_desc6 as "svc_browser-extensions_SECURE_desc" }